import React from 'react'
import {Flex} from '/app/src/component'
import { connect } from 'react-redux'

class TutorialContainer extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isOpen: true
        }
    }

    componentDidMount(){
        setTimeout(this.toggle, 1000);
    }


    render(){
        //Children refers to TutorialItems
        let {children, text} = this.props;
        let numberDone = 0;
        let imgSrc = '/images/ResolveButtonGrey.png';
        let numberItems = 0;
        if(children){
            numberItems = children.length;
            if(numberItems){
                children.forEach((child) => {
                    if(child.props.done){
                        numberDone++
                    }
                })
                if(numberDone === children.length){
                    imgSrc = '/images/ResolveButtonBlue.png';
                }
            }else{
                if(children.props.done){
                    numberItems = 1;
                    numberDone++
                    imgSrc = '/images/ResolveButtonBlue.png';
                }
            }
        }

        return(
            <Flex column padding='20px 20px 0px 20px'>
                <Flex fontSize='22px' color='#868686' vAlignContent='center'>{text} ({numberDone}/{numberItems})
                    <img alt='' src={imgSrc} style={{width: '20px', height: 'auto', left: '10px', position: 'relative'}}/>
                </Flex>
                {children}
            </Flex>
        );
    }
}

function mapStateToProps(state, ownProps)
{
    return{

    }
}

export default connect(mapStateToProps)(TutorialContainer);



// WEBPACK FOOTER //
// ./src/layout/Dashboard/MainPanel/Tutorial/TutorialContainer.js